<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 337.6 335.2" style="enable-background:new 0 0 337.6 335.2;" xml:space="preserve">
    <g>
      <defs>
        <rect id="s5_1_" x="1.5" y="128.2" width="129.3" height="129.3"/>
      </defs>
      <clipPath id="s5_2_">
        <use xlink:href="#s5_1_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st0">
        <g>
          <defs>
            
              <rect id="s5_3_" x="11.3" y="137.8" transform="matrix(0.9717 -0.2363 0.2363 0.9717 -43.5827 21.0203)" width="109.1" height="109.1"/>
          </defs>
          <clipPath id="s5_4_">
            <use xlink:href="#s5_3_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st1">
            <g>
              <defs>
                <path id="s5_5_" d="M8.7,150.1l88.6-21.5c4.8-1.2,9.7,1.8,10.9,6.6l21.5,88.6c1.2,4.8-1.8,9.7-6.6,10.9l-88.6,21.5
                  c-4.8,1.2-9.7-1.8-10.9-6.6L2.1,161C1,156.1,3.9,151.3,8.7,150.1z"/>
              </defs>
              <clipPath id="s5_6_">
                <use xlink:href="#s5_5_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st2">
                <path class="st3" d="M0,152.2l106-25.8l25.8,106.1l-106,25.8L0,152.2z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_7_" x="189.5" y="148.2" width="145.3" height="145.3"/>
      </defs>
      <clipPath id="s5_8_">
        <use xlink:href="#s5_7_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st4">
        <g>
          <defs>
            
              <rect id="s5_9_" x="207.9" y="166" transform="matrix(0.5311 -0.8473 0.8473 0.5311 -63.8197 325.7765)" width="109.1" height="109.1"/>
          </defs>
          <clipPath id="s5_10_">
            <use xlink:href="#s5_9_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st5">
            <g>
              <defs>
                <path id="s5_11_" d="M192,230.2l48.4-77.2c2.6-4.2,8.2-5.5,12.4-2.8l77.2,48.4c4.2,2.6,5.5,8.2,2.8,12.4l-48.4,77.2
                  c-2.6,4.2-8.2,5.5-12.4,2.8l-77.2-48.4C190.6,239.9,189.3,234.4,192,230.2z"/>
              </defs>
              <clipPath id="s5_12_">
                <use xlink:href="#s5_11_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st6">
                <path class="st3" d="M187.2,237.8l58-92.5l92.5,58l-58,92.5L187.2,237.8z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_13_" x="100.2" y="214.9" width="121.3" height="120"/>
      </defs>
      <clipPath id="s5_14_">
        <use xlink:href="#s5_13_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st7">
        <g>
          <defs>
            
              <rect id="s5_15_" x="106.3" y="220" transform="matrix(0.1183 -0.993 0.993 0.1183 -131.0032 401.7345)" width="108.9" height="109.3"/>
          </defs>
          <clipPath id="s5_16_">
            <use xlink:href="#s5_15_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st8">
            <g>
              <defs>
                <path id="s5_17_" d="M121.9,215.2l90.5,10.8c4.9,0.6,8.5,5.1,7.9,10l-10.8,90.2c-0.6,4.9-5.1,8.5-10,7.9L109,323.3
                  c-4.9-0.6-8.5-5.1-7.9-10l10.8-90.2C112.4,218.1,116.9,214.6,121.9,215.2z"/>
              </defs>
              <clipPath id="s5_18_">
                <use xlink:href="#s5_17_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st9">
                <path class="st3" d="M112.9,214.1l108.5,12.9l-12.9,108.1L100,322.2L112.9,214.1z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_19_" x="176.2" y="22.9" width="148" height="148"/>
      </defs>
      <clipPath id="s5_20_">
        <use xlink:href="#s5_19_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st10">
        <g>
          <defs>
            
              <rect id="s5_21_" x="196.1" y="42.1" transform="matrix(0.7604 -0.6495 0.6495 0.7604 -2.7231 185.9504)" width="109.1" height="109.1"/>
          </defs>
          <clipPath id="s5_22_">
            <use xlink:href="#s5_21_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st11">
            <g>
              <defs>
                <path id="s5_23_" d="M180.5,84.8l69.3-59.2c3.8-3.2,9.5-2.8,12.7,1l59.2,69.3c3.2,3.8,2.8,9.5-1,12.7l-69.3,59.2
                  c-3.8,3.2-9.5,2.8-12.7-1l-59.2-69.3C176.3,93.7,176.8,88,180.5,84.8z"/>
              </defs>
              <clipPath id="s5_24_">
                <use xlink:href="#s5_23_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st12">
                <path class="st3" d="M173.7,90.6l83-70.9l70.9,83l-83,70.9L173.7,90.6z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_25_" x="112.7" y="103.7" width="129.8" height="129.8"/>
      </defs>
      <clipPath id="s5_26_">
        <use xlink:href="#s5_25_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st13">
        <g>
          <defs>
            <path id="s5_27_" d="M112.7,224.4V112.7c0-5,4-9,9-9h111.8c5,0,9,4,9,9v111.8c0,5-4,9-9,9H121.7
              C116.7,233.4,112.7,229.4,112.7,224.4z"/>
          </defs>
          <clipPath id="s5_28_">
            <use xlink:href="#s5_27_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st14">
            <path class="st3" d="M112.7,233.4V103.7h129.8v129.8H112.7z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_29_" x="48.2" y="2.9" width="144" height="142.7"/>
      </defs>
      <clipPath id="s5_30_">
        <use xlink:href="#s5_29_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st15">
        <g>
          <defs>
            
              <rect id="s5_31_" x="65.7" y="19.8" transform="matrix(0.8708 -0.4917 0.4917 0.8708 -21.1068 68.7588)" width="109.1" height="109.6"/>
          </defs>
          <clipPath id="s5_32_">
            <use xlink:href="#s5_31_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st16">
            <g>
              <defs>
                <path id="s5_33_" d="M53.6,49.2L133,4.4c4.3-2.4,9.8-0.9,12.3,3.4l44.9,79.5c2.4,4.3,0.9,9.8-3.4,12.3l-79.4,44.8
                  c-4.3,2.4-9.8,0.9-12.3-3.4L50.2,61.5C47.8,57.2,49.3,51.7,53.6,49.2z"/>
              </defs>
              <clipPath id="s5_34_">
                <use xlink:href="#s5_33_"  style="overflow:visible;"/>
              </clipPath>
              <g class="st17">
                <path class="st3" d="M45.8,53.7l95-53.7l53.7,95l-95,53.7L45.8,53.7z"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_35_" x="26.7" y="23.5" width="290" height="290"/>
      </defs>
      <clipPath id="s5_36_">
        <use xlink:href="#s5_35_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st18">
        <g>
          <defs>
            <circle id="s5_37_" cx="171.7" cy="168.5" r="145"/>
          </defs>
          <clipPath id="s5_38_">
            <use xlink:href="#s5_37_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st19">
            <path class="st20" d="M26.7,23.5h290v290h-290V23.5z"/>
          </g>
        </g>
      </g>
    </g>
    <g>
      <defs>
        <rect id="s5_39_" x="86" y="81.8" width="171.5" height="171.5"/>
      </defs>
      <clipPath id="s5_40_">
        <use xlink:href="#s5_39_"  style="overflow:visible;"/>
      </clipPath>
      <g class="st21">
        <g>
          <defs>
            <path id="s5_41_" d="M171.7,81.8c-47.3,0-85.7,38.4-85.7,85.7s38.4,85.7,85.7,85.7c47.3,0,85.7-38.4,85.7-85.7
              S219,81.8,171.7,81.8z"/>
          </defs>
          <clipPath id="s5_42_">
            <use xlink:href="#s5_41_"  style="overflow:visible;"/>
          </clipPath>
          <g class="st22">
            <path class="st3" d="M86,81.8h171.5v171.5H86V81.8z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'r4'
  }
</script>

<style scoped>
  svg {
    width: 100%;
    height: 100%;
  }
</style>

<style scoped>
  .st0{clip-path:url(#s5_2_);}
  .st1{clip-path:url(#s5_4_);}
  .st2{clip-path:url(#s5_6_);}
  .st3{fill:#2C6EDF;}
  .st4{clip-path:url(#s5_8_);}
  .st5{clip-path:url(#s5_10_);}
  .st6{clip-path:url(#s5_12_);}
  .st7{clip-path:url(#s5_14_);}
  .st8{clip-path:url(#s5_16_);}
  .st9{clip-path:url(#s5_18_);}
  .st10{clip-path:url(#s5_20_);}
  .st11{clip-path:url(#s5_22_);}
  .st12{clip-path:url(#s5_24_);}
  .st13{clip-path:url(#s5_26_);}
  .st14{clip-path:url(#s5_28_);}
  .st15{clip-path:url(#s5_30_);}
  .st16{clip-path:url(#s5_32_);}
  .st17{clip-path:url(#s5_34_);}
  .st18{clip-path:url(#s5_36_);}
  .st19{clip-path:url(#s5_38_);}
  .st20{fill:#75A0F1;}
  .st21{clip-path:url(#s5_40_);}
  .st22{clip-path:url(#s5_42_);}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/svg/r5.vue